/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from "clsx";
import { Col, Row, Modal, Space } from "antd";
import { Button, TableRow, TableCell, Typography, TextField } from "@mui/material";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import { useParams, Link } from "react-router-dom";
import moment from 'moment';
import transActions from "../../../Transactions/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { capitalizeFirstLetter, currencyFormat, checkCRUDViewPermission, checkCRUDPermission, checkComponentPermission } from "../../../../../helpers/utilities";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { selectPurchaseInvoiceViewHead, confirmedselectPurchaseInvoiceViewHead } from "../../../../../config/constant";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import { CustomModal } from "../../../../Shared/components/DeleteModal";

const SupplierPaymentView = (props) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reason, setReason] = useState('');
    const { deleteDetails, readDetails, createDetails, createError, createLoader, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);

    const [errorReason, setErrorReason] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const dispatch = useDispatch();
    const { history } = props;
    const { paymentId, customiseId } = useParams();
    const decryptedId = AESDecrypt(paymentId);
    const prevReadDetails = usePrevious(readDetails);
    const prevDeleteDetails = usePrevious(deleteDetails);
    const [showDetails, setShowDetails] = useState(true);
    const [confirm, setConfirm] = useState(false);
    const { roleManagement } = useSelector(state => state.authReducer);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const onDelete = () => {
        setIsModalVisible(true);
    }

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
        }
    }, [readDetails]);

    const handleCancel = () => {
        setIsModalVisible(false);
        setErrorReason(false);
        setReason('');
    };

    useEffect(() => {
        if (paymentId === undefined || decryptedId === 0) {
            history.push("/purchase/purchase-management/supplier-payment");
            return true;
        }

        if (roleManagement !== '' && checkCRUDViewPermission('Supplier Payment', 'view', history, 'Purchase')) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "supplierPayment" });
        }

        return () => {
            dispatch({ type: transActions.CLEAR_PURCHASE_TRANSACTION_DETAILS_START });
        }
    }, [paymentId, roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/edit`);
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            setConfirm(true);
        }

        // else if (e.altKey && e.keyCode === 83) {
        //     e.preventDefault();
        //     if(confirm){
        //         handleStatus('CONFIRMED')
        //     }
        // }
    }

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(editDetails);
            setConfirm(false);
            history.push("/purchase/purchase-management/supplier-payment");
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            setErrorReason('');
            handleCancel();
            history.push("/purchase/purchase-management/supplier-payment");
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);

    const handleStatus = (status) => {
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `/supplierPayment/${decryptedId}/confirmPayment`,
            title: 'Supplier Payment'
        });
    }

    const deletePayment = (e) => {
        e.preventDefault();
        let emptyReason = emptyValidation('Reason', reason);
        if (emptyReason.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'supplierPayment',
                title: 'Supplier Payment',
                id: decryptedId,
                slug: "cancel",
                details: {
                    paymentStatus: 'CANCELLED',
                    reversalReason: reason
                }
            });
        } else {
            if (emptyReason.errors) {
                setErrorReason(emptyReason.errors);
            }
        }
    }

    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            setIsModalVisible(false);
            toast.dismiss();
            toast(deleteDetails);
            history.push("/purchase/purchase-management/supplier-payment");
        }
    }, [deleteDetails]);


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props}
                closeLink={customiseId ? '' : '/purchase/purchase-management/supplier-payment'}
                img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Payments', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'View Payment'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails && (
                                        <Row gutter={50} className={clsx(classes.ButtonRelative)}>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={24} xs={24}>
                                                <Typography className={clsx(classes.aTitle)}>{`${readDetails.serialNo}`}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={14}>
                                                <span className={clsx(classes.statusButton, classes.thirdBox, classes.disInline, { [classes.confirmedButton]: readDetails.paymentStatus === 'CONFIRMED' }, { [classes.reversedButton]: readDetails.paymentStatus === 'CANCELLED' })}>{capitalizeFirstLetter(readDetails.paymentStatus)}</span>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={12} md={8} sm={12} xs={10} className={clsx(classes.textAlignRight, classes.ButtonStatic, classes.thirdBox, classes.displayFlexPayment)}>
                                                <Space direction="horizontal" align="center">
                                                    {
                                                        !readDetails.supplier.isHold && <Space direction="horizontal" align="center" size={[10, 10]}
                                                            className={clsx(classes.ButtonAbsolute, classes.OverallPaymentButton)}>
                                                            {
                                                                (readDetails.paymentStatus === 'CREATED') &&
                                                                <>
                                                                    {
                                                                        roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'edit', 'Purchase') &&
                                                                        <Link to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(decryptedId)}/edit`} className={clsx(classes.AddMoreBtn, classes.bold, classes.marginRight0)}>Edit</Link>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'Confirm') &&
                                                                        <Button
                                                                            key="Cancel"
                                                                            color="primary"
                                                                            variant="contained"
                                                                            onClick={() => setConfirm(true)}
                                                                            className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loading]: createLoader })}
                                                                        >Confirm</Button>
                                                                    }
                                                                </>
                                                            }
                                                            {
                                                                readDetails.paymentStatus === 'CONFIRMED' && <>

                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Action', 'View Cancel') && !readDetails?.supplierPaymentItems &&
                                                                        <Button
                                                                            key="Cancel"
                                                                            color="primary"
                                                                            variant="contained"
                                                                            className={clsx(classes.deleteBtn, classes.marginRight0)}
                                                                            onClick={() => onDelete(readDetails)}
                                                                        >Cancel</Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Space>
                                                    }

                                                </Space>
                                            </Col>
                                            <Col xxl={10} xl={10} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Supplier Name</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.supplier ? readDetails.supplier.name : '---'}</Typography>
                                            </Col>

                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Date</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moment(readDetails.date).format('DD MMM YYYY')}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Method Of Payment</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mop ? readDetails.mop.method : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Currency</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.currency ? readDetails.currency.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Supplier ID</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.supplier?.serialNo ? readDetails.supplier?.serialNo : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Amount</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(readDetails.paymentAmount)}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Reference (Optional)</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.reference ? readDetails.reference : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Description (Optional)</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.descEllipsis)}>{readDetails.description ? readDetails.description : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Payment Status</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(readDetails.paymentStatus)}</Typography>
                                            </Col>
                                            <Col xxl={19} xl={19} lg={19} md={19} sm={19} xs={19}></Col>
                                        </Row>
                                    )
                                }
                                {
                                    showDetails === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Selected Invoice'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        component={
                            <div className={classes.tableRoot} style={{ height: "100%" }}>
                                <CustomInfiniteScroll
                                    styles={'height:100%'}
                                    heads={readDetails.paymentStatus === 'CONFIRMED' ? selectPurchaseInvoiceViewHead : confirmedselectPurchaseInvoiceViewHead}
                                    width={true}
                                    loadMore={true}
                                    customClasses={classes.tableRoot}
                                    loadMoreContent={false}
                                    component={
                                        <>
                                            {
                                                showDetails === false ? (readDetails?.supplierPaymentItems?.length > 0 ? readDetails?.supplierPaymentItems.map((data, i) => (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}  >
                                                        <TableCell>{data?.purchaseInvoice.serialNo}</TableCell>
                                                        <TableCell>{data?.purchaseInvoice.supplierRefNum}</TableCell>
                                                        <TableCell>{moment(data?.purchaseInvoice.invoiceDate).format('DD MMM YYYY')}</TableCell>
                                                        <TableCell className={classes.textAlignRight}>₹ {data?.purchaseInvoice.invoiceAmount ? currencyFormat(data.purchaseInvoice.invoiceAmount) : '0.00'}</TableCell>
                                                        <TableCell>₹ {data.amountToSettle ? currencyFormat(data.amountToSettle) : '0.00'}</TableCell>
                                                    </TableRow>
                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                            {readDetails.paymentStatus === 'CONFIRMED' ? 'No invoices has been settled against this payment' : 'No invoices has been selected to settle against this payment.'}
                                                        </p>
                                                    </TableCell>
                                                </TableRow>) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>
                                            }
                                        </>
                                    }
                                />
                            </div>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <Modal
                title={'Reason for Cancellation'}
                open={isModalVisible}
                onOk={() => handleCancel()}
                onCancel={() => handleCancel()}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="Confirm"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                        onClick={(e) => deletePayment(e)}
                    >Confirm</Button>,
                ]}
            >
                <TextField autoComplete='one-time-code' label='Enter the reason for Cancellation'
                    fullWidth
                    variant={'standard'}
                    error={errorReason && true}
                    helperText={errorReason}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor,
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Modal>
            <CustomModal
                visible={confirm}
                yesButton={'Yes'}
                noButton={'No'}
                loading={createLoader}
                title={'Payment Confirmation'}
                onOpen={() => handleStatus('CONFIRMED')}
                onClose={() => setConfirm(false)}
                text={<p>Are you sure do you want to Confirm the Payment?</p>}
            />
        </React.Fragment>
    )
}
export default SupplierPaymentView